import { BehaviorSubject, filter, map, Observable } from 'rxjs';
import { FlowDto, FlowManagerService, ProcessFlowDto } from '@swagger-services/flow';
import { environment } from '../../environments/environment';
import { NavController } from '@ionic/angular/standalone';
import { AuthService } from '@services/auth.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export abstract class FlowService {
  private readonly _flowConfig$ = new BehaviorSubject<FlowDto | undefined>(undefined);

  constructor(
    private readonly flowManagerService: FlowManagerService,
    protected readonly navController: NavController,
    protected readonly authService: AuthService,
  ) {}

  get flowConfig(): FlowDto | undefined {
    return this._flowConfig$.value;
  }

  get flowConfig$(): Observable<FlowDto | undefined> {
    return this._flowConfig$.asObservable();
  }

  get flowStepData(): any {
    return this.flowConfig!.nextStepData || this.flowConfig!.currentStepData;
  }

  get flowStepData$(): Observable<any | undefined> {
    return this._flowConfig$.pipe(
      filter((flowData: any) => !!flowData),
      map((flowData) => flowData.nextStepData || flowData.currentStepData),
    );
  }

  private updateFlowData(config: FlowDto): void {
    this._flowConfig$.next(config);
  }

  async process(data: ProcessFlowDto, startFlow = false, skipRedirect = false): Promise<FlowDto | void> {
    try {
      const config = await this.flowManagerService.flowManagerPatientControllerProcessFlow(environment.orgSlug, data);
      this.updateFlowData(config);
      if ((startFlow && config.done) || skipRedirect) {
        return config;
      }
      this.redirectUserToNextStep(data.back);
      return config;
    } catch {
      // TODO: Add error handling for other cases
    }
  }

  clearService(): void {
    this._flowConfig$.next(undefined);
  }

  // Abstract method that must be implemented by the derived class
  protected abstract redirectUserToNextStep(back?: boolean): void;

  abstract processFlow(data?: Partial<ProcessFlowDto>): Promise<any>;
}
